import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { MouseEvent } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { useConfirmStore } from "../../stores/Confirm";
import { useMutation } from "@tanstack/react-query";

export default function ConfirmDialog() {
  const confirm = useConfirmStore((state) => state.confirm);
  const closeConfirmDialog = useConfirmStore(
    (state) => state.closeConfirmDialog
  );
  const { t } = useTranslation("ConfirmDialog");
  const open = Boolean(confirm);

  const { mutate: run, isPending } = useMutation({
    mutationFn: async () => {
      if (!confirm?.function) return;
      await confirm.function();
    },
    onSettled: () => {
      handleClose();
    },
  });

  const handleConfirm = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    run();
  };

  const handleClose = () => {
    closeConfirmDialog();
  };

  return (
    <Dialog
      open={open}
      onClose={isPending ? undefined : handleClose}
      sx={{ zIndex: 999999 }}
    >
      <DialogTitle
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography fontWeight={600}>
          {confirm?.title || t("Confirm")}
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ minWidth: { xs: 300, md: 400 } }}>
        <DialogContentText>{confirm?.text || t("Question")}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3, pb: 2, pt: 0 }}>
        <Button
          variant="outlined"
          color="error"
          onClick={handleClose}
          disabled={isPending}
        >
          {t("Cancel")}
        </Button>
        <Button
          autoFocus
          variant="contained"
          onClick={handleConfirm}
          type="submit"
          loading={isPending}
        >
          {t("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
